import { getAccessToken } from '../authentication/supabaseService';

const API_BASE = '/api/admin';

// ── Types (mirror server/domains/setupScore/userActivityService.ts) ──

export interface UserActivityUser {
  userId: string;
  email: string;
  role: string;
  lastSeen: string | null; // ISO timestamp of last $pageview, or null
}

export interface UserActivityRestaurant {
  restaurantId: string;
  restaurantName: string;
  users: UserActivityUser[];
}

export interface UserActivityClient {
  clientId: string;
  clientName: string | null;
  clientEmail: string;
  restaurants: UserActivityRestaurant[];
}

export interface UserActivityResponse {
  configured: boolean;
  generatedAt: string;
  clients: UserActivityClient[];
}

async function fetchWithAuth(endpoint: string) {
  const token = await getAccessToken();
  const response = await fetch(`${API_BASE}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch ${endpoint}: ${response.statusText}`);
  }
  return response.json();
}

export async function getUserActivity(): Promise<UserActivityResponse> {
  return fetchWithAuth('/user-activity');
}
